import { Navigate, createFileRoute } from "@tanstack/react-router";

function OkrsOkrsRedirect() {
  return <Navigate to="/okrs/org-chart" replace />;
}

export const Route = createFileRoute("/_app/okrs/okrs")({
  component: OkrsOkrsRedirect,
});
